import React from "react";

function NotFound() {
  return (
    <div className="container">
      <h2>404 - Page Not Found</h2>
    </div>
  );
}

export default NotFound;
